import { SITE_SURVEYS_CRUD_ACTION_CREATORS } from '../actions/site_surveys_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';
import { getBackendUri } from '../utils/EnvConfigUtils';

const fetchUtils = new FetchUtils();
export const siteSurveysRestCrudThunksForBuyer = new RestCrudThunks(
	'site_surveys',
	'site_survey',
	'siteSurvey',
	'siteSurveys',
	SITE_SURVEYS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'site_survey/'
);

export const siteSurveysRestCrudThunksForSupplier = new RestCrudThunks(
	'site_surveys',
	'site_survey',
	'siteSurvey',
	'siteSurveys',
	SITE_SURVEYS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'site_survey/'
);

export const siteSurveysLite =
	(roleType) =>
	(
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) => {
		if (pagination) {
			const paginationQuery = {
				offset: (pagination.current - 1) * pagination.pageSize,
				limit: pagination.pageSize,
			};
			params = {
				...params,
				...paginationQuery,
			};
		}

		// if sorting present, fix order naming and add to query params
		if (sorting) {
			const sortingQuery = { ...sorting, order: sorting.order === 'ascend' ? 'asc' : 'desc' };
			params = {
				...params,
				...sortingQuery,
			};
		}
		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(
						getBackendUri() + `/api/v1/${roleType}/site_survey/walkthroughs/lite`,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((d) => {
						if (d.isCancelled) {
							console.log(`Cancelled Promise....${targetCollectionName}`);
						} else {
							reject(d.message);
						}
					});
			});
		};
	};

export const bulkCreateSiteSurveys =
	(roleType = 'buyer') =>
	(entity) => {
		const apiURL = `/api/v1/${roleType}/site_survey/site_surveys/bulk`;
		const baseUrl = getBackendUri();
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(SITE_SURVEYS_CRUD_ACTION_CREATORS.updateStart(entity));
				fetchUtils
					.post(baseUrl + apiURL, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (d.status === 'error') {
							dispatch(SITE_SURVEYS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(SITE_SURVEYS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(SITE_SURVEYS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

export const bulkUpdateSiteSurveys =
	(roleType = 'buyer') =>
	(entity) => {
		const apiURL = `/api/v1/${roleType}/site_survey/site_surveys/bulk`;
		const baseUrl = getBackendUri();
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(SITE_SURVEYS_CRUD_ACTION_CREATORS.updateStart(entity));
				fetchUtils
					.put(baseUrl + apiURL, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (d.status === 'error') {
							dispatch(SITE_SURVEYS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(SITE_SURVEYS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(SITE_SURVEYS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};
